const BUCKET = "majda";

export function fromKey(key: string) {
    return `https://s3.kyberna.cz/${BUCKET}/${key}`
}